import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

type RouteMessageProps = {
  title: string;
  message: string;
};

/** In-app (inside the main layout) message for unknown paths and views the user can't access. */
export const RouteMessage = ({ title, message }: RouteMessageProps) => {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 200px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        px: 2,
        bgcolor: '#0a0a0a',
      }}
    >
      <Typography variant="h5" sx={{ color: '#fafafa', fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ color: '#a1a1aa', maxWidth: 480 }}>
        {message}
      </Typography>
      <Button variant="contained" component={RouterLink} to="/" sx={{ mt: 1, bgcolor: '#fafafa', color: '#0a0a0a', '&:hover': { bgcolor: '#e4e4e7' } }}>
        Go to Home
      </Button>
    </Box>
  );
};
